export default "__VITE_ASSET__BgJiUcm6__"